import React from 'react';
import { Chip, Tooltip } from '@mui/material';
import ColorPalette from '../../../../colorpalette/ColorPalette';

/**
 * Selo "Atualizada": a lição ganhou uma versão nova depois que a pessoa assistiu.
 * Ela continua contando como assistida; o selo só convida a rever.
 * @param {String} size - 'small' (player) ou 'tiny' (lista de lições)
 */
const LessonUpdatedChip = ({ size = 'small' }) => (
  <Tooltip title="O vídeo desta lição foi atualizado depois que você assistiu" arrow>
    <Chip
      size="small"
      label="Atualizada"
      sx={{
        backgroundColor: ColorPalette.blueAlpha,
        color: ColorPalette.blueMain,
        fontWeight: 600,
        fontSize: size === 'tiny' ? '0.68rem' : '0.72rem',
        height: size === 'tiny' ? 20 : 24
      }}
    />
  </Tooltip>
);

export default LessonUpdatedChip;
